import PatternAddSection, { type PatternAddSectionValue } from "@/components/tasks/patterns/PatternAddSection/PatternAddSection";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export type PatternAddDialogState = {
  listId: number;
  listName: string;
  listColor: string | null;
  listBgColor: string | null;
  section: PatternAddSectionValue;
};

export default function PatternAddDialog({
  value,
  pending,
  onChange,
  onClose,
  onAdd,
}: {
  value: PatternAddDialogState | null;
  pending: boolean;
  onChange: (value: PatternAddDialogState) => void;
  onClose: () => void;
  onAdd: (value: PatternAddDialogState) => void;
}) {
  return (
    <Dialog
      open={!!value}
      onOpenChange={open => {
        if (!open) onClose();
      }}
    >
      <DialogContent className="max-w-2xl max-h-[88dvh] overflow-hidden flex flex-col">
        <DialogHeader>
          <DialogTitle>Add pattern</DialogTitle>
        </DialogHeader>
        {value && (
          <div className="flex min-h-0 flex-col gap-4">
            <div className="min-h-0 overflow-y-auto pr-1">
              <PatternAddSection
                value={value.section}
                onChange={section => onChange({ ...value, section })}
                listName={value.listName}
                listColor={value.listColor}
                listBgColor={value.listBgColor}
              />
            </div>
            <div className="flex shrink-0 justify-end gap-2 border-t border-border/60 pt-3">
              <Button variant="outline" onClick={onClose}>
                Cancel
              </Button>
              <Button disabled={pending} onClick={() => onAdd(value)}>
                Add to today
              </Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
